import { render, staticRenderFns } from "./MongoDBCard.vue?vue&type=template&id=977de366&scoped=true"
import script from "./MongoDBCard.vue?vue&type=script&lang=js"
export * from "./MongoDBCard.vue?vue&type=script&lang=js"
import style0 from "./MongoDBCard.vue?vue&type=style&index=0&id=977de366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977de366",
  null
  
)

export default component.exports